import React from "react";
import Footer from "../Footer/Footer";
import Navbars from "../Navbar/Navbar";
import ScrollToTop from "../ScrollTop";

export default function TermsAndConditions() {
  return (
    <div>
      <Navbars />
      <ScrollToTop />
      <div
        style={{ backgroundColor: "#050810", color: "white" }}
        className="Homemargin"
      >
        <div
          className="d-flex p-4"
          style={{
            justifyContent: "center",
            alignItems: "center",
            fontFamily: "NunitoBlack",
          }}
        >
          <p style={{ color: "#f9c130", fontSize: "30px" }}>
            Terms And Conditions
          </p>
        </div>
        <div
          className="container"
          style={{ lineHeight: 2, fontFamily: "JosefinSans", fontSize: "18px" }}
        >
          <div class="page" title="Page 1">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    1. Introduction:
                  </p>
                  <p>
                    These terms and conditions ("Terms") govern your access to
                    and use of the skill-based game WolfWin/WolfWinPlay by Dwija
                    LLC ("Application"/"App") and its Platform (defined below).
                    These Terms constitute a binding agreement between you
                    (hereinafter "you" or "your") and Dwija LLC, having its
                    registered office at 241 Forest Ave, Paramus, NJ 07652
                    (hereinafter referred to as "we" or "us" or "our" or
                    "Dwija", which expression shall include its successors,
                    licensors, assignors, assignees, affiliates, partners,
                    owners by whichever name called).
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    2. Platform:
                  </p>
                  <p>
                    The Application can be downloaded freely from the AppStore
                    and Google Play Store, subject to its terms and conditions
                    and the privacy policy. It may also be available for
                    download through our website www.wolfwinplay.com.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    3. Eligibility:
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    3.1. United States (U.S.):
                  </p>
                  <p>
                    In order to register an Account, participate in any
                    Competition, receive Services, or download Software, certain
                    eligibility criteria must be met: (a) You must be a natural
                    person who is 18 years of age or older, and the email
                    address used for Account registration must be assigned to
                    you personally. (b) You must possess the legal capacity to
                    enter into a contract with Dwija. (c) You must be physically
                    located within a U.S. state where participation in the
                    selected Competition is unrestricted by state laws. (d) It
                    is essential to consistently adhere to these Terms and abide
                    by them. Failure to meet any of these requirements may
                    result in the suspension or closure of your Account by us
                    with or without prior notice.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    3.2. Non-US:
                  </p>
                  <p>
                    In order to register an Account, participate in any contest,
                    receive Services, or download Software, certain eligibility
                    criteria must be met: (a) You must be a natural person who
                    is 18 years of age or older, and the email address used for
                    Account registration must be assigned to you personally. (b)
                    You must possess the legal capacity to enter into a contract
                    with Dwija. (c) You must be physically located in a
                    jurisdiction in which participation in the Contest you
                    select is permitted and unrestricted by that state or
                    country’s laws. (d) It is essential to consistently adhere
                    to these Terms and abide by them. Failure to meet any of
                    these requirements may result in the suspension or closure
                    of your Account by us with or without prior notice.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 2">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    3.3. Additional Eligibility:
                  </p>
                  <p>
                    By using the Application, Services, or Platform, users agree
                    that their participation in games or any other activities
                    offered therein is solely for entertainment purposes and not
                    in the course of their business or profession.
                  </p>
                  <p>
                    No individuals involved in the development of the
                    Application, Services, or Platform are permitted to
                    participate in any Games that could potentially affect their
                    performance in the Game without obtaining our explicit
                    written permission and complying with any additional terms
                    and conditions we may impose.
                  </p>
                  <p>
                    We reserve the right to terminate your Account and/or deny
                    access to the Application, Services, or Platform if we
                    become aware of any violations of these Terms, the Privacy
                    Policy, or applicable laws.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    4. Compliance With Laws:
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    4.1. Prohibited US States/Countries:
                  </p>
                  <p>
                    Participation in contests is subject to various rules,
                    regulations, and laws, collectively referred to as "Gaming
                    Laws." These Gaming Laws are established by individual US
                    states, countries, territories, or jurisdictions. Therefore,
                    it is important to note that the Software strictly prohibits
                    offering Cash Competition to users in any state where such
                    Competition would violate the applicable Gaming Laws
                    ("Prohibited Jurisdiction"). If you are located in a
                    Prohibited Jurisdiction, you are not permitted to
                    participate in our game. We do not offer any Cash
                    Competition. However, to be extra precautionary, we have
                    specifically banned participation of users from Prohibited
                    Jurisdiction as mentioned below.
                  </p>
                  <p>
                    As of the "Updated" date mentioned above, the Prohibited
                    Jurisdictions in the United States include Arizona,
                    Arkansas, Connecticut, Delaware, Louisiana, Montana, South
                    Carolina, South Dakota, and Tennessee. It is your
                    responsibility to determine whether the state, country,
                    territory, or jurisdiction in which you are located is
                    classified as a Prohibited Jurisdiction. Please be aware
                    that we, in collaboration with our developer partners,
                    reserve the right (although not obligated) to monitor the
                    location from which you access the Services. On behalf of
                    our developer partners, we may block access from any
                    Prohibited Jurisdiction. Additionally, each time you log in
                    to our platform, it is essential to accurately confirm the
                    location from which you are playing.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 3">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    4.2. WolfWin accepts players from the following countries:
                  </p>
                  <p>
                    Albania, Argentina, Armenia, Australia, Austria, Bahamas,
                    Bangladesh, Barbados, Brazil, Canada, Central, African
                    Republic, Chile, Costa Rica, Cyprus, Czech Republic,
                    Denmark, Dominica, Dominican Republic, Ecuador, El Salvador,
                    Finland, Georgia, Germany, Iceland, India, Indonesia,
                    Ireland, Israel, Kuwait, Liechtenstein, Luxembourg, Malawi,
                    Malaysia, Maldives, Mali, Malta, Marshall Islands,
                    Mauritius, Mexico, Moldova, Monaco, Mongolia, Morocco,
                    Nepal, Netherlands, New Zealand, Norway, Panama, Paraguay,
                    Peru, Qatar, Saudi Arabia, Singapore, Slovakia, South
                    Africa, South Korea, Spain, Sri Lanka, Suriname, Swaziland,
                    Sweden, Switzerland, Tajikistan, Tanzania, Thailand, Uganda,
                    United Arab Emirates, United Kingdom, United States,
                    Uruguay, Vanuatu, Vatican City.
                  </p>
                  <p>
                    For United States, currently available in the state of
                    Alabama, Alaska, California, Colorado, Florida, Georgia,
                    Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky,
                    Maine, Maryland, Massachusetts, Michigan, Minnesota,
                    Mississippi, Missouri, Nebraska, Nevada, New Hampshire, New
                    Jersey, New Mexico, New York, North Carolina, North Dakota,
                    Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, Texas,
                    Utah, Vermont, Virginia, Washington, West Virginia,
                    Wisconsin, and Wyoming.
                  </p>
                  <p>
                    For Australia, currently available in Western Australia,
                    South Australia, and Northern Territory.
                  </p>
                  <p>
                    For India, currently available in Arunachal Pradesh, Bihar,
                    Chhattisgarh, Goa, Gujarat, Haryana, Himachal Pradesh, Jammu
                    and Kashmir, Jharkhand, Kerala, Madhya Pradesh, Maharashtra,
                    Manipur, Mizoram, Punjab, Rajasthan, Tamil Nadu, Tripura,
                    Uttar Pradesh, Uttarakhand, and West Bengal.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    4.3. Prohibited Countries/Regions :
                  </p>
                  <p>
                    Afghanistan, Belarus, Belgium, Bosnia And Herzegovina,
                    Bulgaria, Colombia, Congo (Democratic Republic), Cote
                    D’Ivoire, Croatia (local name: Hrvatska), Cuba, Cyprus,
                    Czech Republic, Egypt, Estonia, France, French Guiana,
                    French Polynesia, French Southern Territories, Greece,
                    Haiti, Hungary, Indonesia, Iran (Islamic Republic Of), Iraq,
                    Italy, Japan, Kosovo, Latvia, Lithuania, Malaysia, Malta,
                    Montenegro, Myanmar, Nepal, Nigeria, North Korea, North
                    Macedonia, Pakistan, People’s Republic of China,
                    Philippines, Poland, Portugal, Romania, Russian Federation,
                    Serbia, Slovakia (Slovak Republic), Slovenia, Syrian Arab
                    Republic, Turkey, Ukraine, Venezuela, Vietnam, Yugoslavia,
                    Zimbabwe.
                  </p>
                  <p>
                    For Australia, not currently available in Queensland or
                    Victoria, New South Wales, or Canberra.
                  </p>
                  <p>
                    For India, wolfwin currently not be available in Andhra
                    Pradesh, Assam, Karnataka, Meghalaya, Nagaland, Odisha,
                    Sikkim, and Telangana.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    4.4. Additional Compliance With Laws:
                  </p>
                  <p>
                    In addition to Gaming Laws, it is essential to comply with
                    all municipal, state, and federal laws, rules, and
                    regulations of your city, state, and country of residence,
                    as well as the jurisdiction from which you access and
                    utilize the Services. This includes, but is not limited to,
                    U.S. export laws. Collectively, these laws are referred to
                    as "Applicable Laws." It is your sole responsibility to
                    ensure compliance with all Applicable Laws. Your decision to
                    participate on our platform is undertaken at your own risk,
                    and you agree not to hold us liable if Applicable Laws
                    restrict or prohibit your access or participation.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    4.5. Legal Disclaimer:
                  </p>
                  <p>
                    We do not make any representations or warranties, whether
                    express or implied, regarding the legality of your
                    participation in our platform offered by our developer
                    partners or the use of Services. Furthermore, no person
                    affiliated with us, or claiming affiliation, has the
                    authority to make such representations or warranties.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    5. Agreement to Terms:
                  </p>
                  <p>
                    Please read these Terms carefully before you use the
                    Application or any Service offered through the Application.
                    By registering for an Account with us, utilizing the
                    Services in any manner, clicking the "I accept" button
                    below, downloading any Software of Dwija’s, or registering
                    for and participating on our platform, you: (A) acknowledge
                    that you have thoroughly read these Terms and Conditions of
                    Service (B) agree to be legally bound by the Terms; and (C)
                    confirm that you possess the necessary authorization and
                    capacity to accept these Terms. If you do not wish to be
                    bound by the Terms, refrain from clicking "I accept,"
                    abstain from registering with Dwija, and avoid using the
                    Services. Declining to accept these Terms will result in
                    your inability to participate in Competitions or access your
                    account.
                  </p>
                  <p>
                    Your continued use of the Application and/or the Services
                    offered through the Application will imply your acceptance
                    of the conditions contained under these Terms. We grant such
                    users a non-transferable, limited, non-exclusive, and
                    revocable privilege to register an Account on and use the
                    Application.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 4">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    6. Electronic Agreement:
                  </p>
                  <p>
                    These Terms constitute an 'electronic record' within the
                    meaning of the laws of the United States and are generated
                    by a computer system and do not require any physical or
                    digital signatures. These Terms can vary depending on the
                    states or country user is located in. Therefore, users must
                    be held accountable for following required regulations in
                    their area.. By using the Services, you agree to contract
                    electronically with us and agree to these Terms, together
                    with any documents that may be expressly referred to and are
                    incorporated by reference herein, including our Privacy
                    Policy. You agree that these electronic terms, combined with
                    your act of using these Services, have the same force and
                    effect as your written signature and satisfy any laws that
                    require a writing or signature. You shall not use the
                    services if you: (a) do not agree to these Terms; (b) are
                    not of the age of 18 years; or (c) are from the
                    aforementioned Restricted States or Restricted Territory or
                    are prohibited from accessing or using the Services,
                    products, or services by applicable law.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    7. Amendment of Terms:
                  </p>
                  <p>
                    We reserve the right to periodically review, update, change,
                    or replace any part of these Terms on our website at
                    wolfwinplay.com at our sole and absolute discretion without
                    any prior notice to you, and all changes are effective
                    immediately upon being posted on the Website. You must visit
                    this page periodically for updates on the Terms. Your
                    continued usage of the Platform and/or the Application after
                    any such update, change, replacement, or modification to
                    these terms constitutes your valid consent to such changes.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 5">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    8. Nature and use of the Application:
                  </p>
                  <p>
                    The Application serves as an online platform that enables
                    users to engage in skill-based online real money games with
                    other users.
                  </p>
                  <p>
                    To use and access the Application and its Services, you are
                    required to create an account on the Application using your
                    mobile device and logging in through your Gmail account.
                  </p>
                  <p>
                    By utilizing the Application, you acknowledge the importance
                    of securing access to your mobile device to prevent
                    unauthorized use of your Account on the Application or any
                    unauthorized access to the Services using your login
                    credentials. You are solely responsible for any activity
                    that occurs under your Account and must promptly notify us
                    if you suspect any unauthorized use. It is essential to
                    provide accurate and complete information during the
                    registration process and promptly update any changes to your
                    provided information.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    9. Participation in Contests:
                  </p>
                  <p>
                    The Application allows you to participate in various
                    Contests available on the platform. These Contests may
                    include 1v1 contests, multiplayer tournaments, and other
                    formats introduced from time to time. 1v1 battles refer to
                    player vs player battles in these Terms. Some Contests may
                    require an addmission to participate, which will be deducted
                    from your relevant wallet according to the Terms specified
                    below.
                  </p>
                  <p>
                    All types of fees mentioned on our platform is in-app
                    virtual currency, which is exclusively intended for in-app
                    use only and holds no real-world cash value.
                  </p>
                  <p>
                    To certain join a Contest, you can have to enter with in-app
                    virtual currency. We may charge a in-app virtual currency
                    platform fee for certain Contests. Please be aware that
                    in-app virtual currency is exclusively intended for in-app
                    use only and holds no real-world cash value.
                  </p>
                  <p>
                    The Application provides detailed information for each game,
                    including the addmission amount, the winning amount, and
                    platform fees. It is advised that users review these details
                    before participating in any Contest. We are not liable for
                    any failure on your part to familiarize yourself with the
                    game-specific details, fees, rules, or regulations.
                  </p>
                  <p>
                    When participating in a certain Contest, the in-app currency
                    will be debited from the relevant wallets in the following
                    order: (1) Bonus Wallet (fixed percentage), (2) Deposit
                    Wallet, and (3) Winnings Wallet. The complete signup bonus
                    of in-app virtual currency will be credited to the Deposit
                    Wallet and can be used for playing games on the Application.
                  </p>
                  <p>
                    All amounts in the Winnings Wallet or Deposit Wallet must be
                    utilized within 365 days. If any amount remains unutilized
                    due to inactivity after 365 days, we reserve the right to
                    forfeit it without compensation. We will maintain records of
                    the Account and transactions as required by law. Only a
                    fixed percentage of the Bonus Wallet amount, depending on
                    the Game, can be utilized for entering into a Contest at a
                    given time.
                  </p>
                  <p>
                    Contests will be announced on the Application at our
                    discretion. We reserve the right to extend participation and
                    registration time limits, cancel Contests, and modify terms,
                    with or without notice to Application users.
                  </p>
                  <p>
                    We do not issue receipts for Contest participation.
                    Participation in a Contest is recorded within the user's
                    Account on the Application. If a user requires a tax invoice
                    for the amount charged by Dwija, they can make a request to
                    our customer support team in accordance with these Terms.
                  </p>
                  <p>
                    You agree to pay applicable taxes, levies, and any other
                    statutory or government dues, as required by applicable law,
                    in relation to the Games and Contests. We reserve the right
                    to change the charges and specifications associated with the
                    Application, including subscriptions, deals, and Games,
                    among others.
                  </p>
                  <p>
                    If a user leaves a Game after it has started and before it
                    ends for any reason, their fees for the contest will be
                    retained by opponent player or Us.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 6">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    10. Determining Winner:
                  </p>
                  <p>
                    Each Player is given same set of gameplay or puzzle to
                    solve. Each player has same time limit. It is through users’
                    skill, speed, and efficiency that they strive to achieve the
                    highest score. Our scoring system rewards completing in-game
                    level/task and effective gameplay. User with the highest
                    score is determined as the winner of that particular
                    Contest.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    11. Purchasing and Using in-App Virtual Currency for
                    Enhanced In-Game Experience:
                  </p>
                  <p>
                    Users have the option to purchase in-app virtual currency
                    packages within our game to enhance their in-game
                    experience. This virtual currency is a valuable in-app
                    resource that can be used for various functions and
                    features, such as unlocking premium contests, and
                    participating in special in-app activities. Please be aware
                    that in-app virtual currency is exclusively intended for
                    in-app use only and holds no real-world cash value.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 8">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    12. Redemtion:
                  </p>
                  <p>
                    You have the option to request a redemption of your funds.
                    Please be aware that Promotional and Bonus amounts cannot be
                    redeemed. The processing time for redemptions may extend up
                    to ninety (90) days, although we endeavor to expedite the
                    process whenever possible. Each withdrawal is manually
                    processed to ensure safety and security, which may result in
                    a slight delay. Rest assured, we continuously work to
                    streamline the withdrawal process for your convenience.
                    Please note that a Know Your Customer (KYC) verification
                    will be conducted for all redemptions. However, we reserve
                    the right to temporarily freeze your Account and/or delay
                    the request under certain circumstances. During the pending
                    withdrawal period, additional deposits are not permitted,
                    but you can cancel your pending withdrawal and use those
                    funds for gameplay. To cancel a withdrawal request, you may
                    contact us with your User ID number, the withdrawal amount,
                    and the date to request a cancellation on your behalf.
                  </p>
                  <p>
                    If you are a U.S. resident, we may send you an IRS Form W-9
                    and 1099-MISC or other appropriate form if your redemption
                    total is $600 or more in any given calendar year. Depending
                    on the state in which you reside, we may also send you
                    additional federal or state tax forms. We may withhold from
                    your existing Account balance and/or from future Winnings
                    any amount required to be withheld by Applicable Laws,
                    including amounts due in connection with your failure to
                    complete relevant tax documentation, but you remain solely
                    responsible for paying all federal, state and other taxes in
                    accordance with all Applicable Laws.
                  </p>
                  <p>
                    For residents of India, a flat rate of 30% tax will be
                    applied to your net redemption amount. The tax will be
                    deducted from the user’s account at the time of redemption.
                  </p>
                  <p>
                    For residents of other countries, the taxation and related
                    documentation for redemptions will be handled in accordance
                    with the laws of the respective country.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    13. Taxes:
                  </p>
                  <p>
                    If you are a U.S. resident, it is important to note that we
                    may be required to send you tax forms under certain
                    circumstance. Depending on your state of residence, you may
                    also receive additional federal or state tax forms from us.
                    However, it is crucial to remember that you are solely
                    responsible for fulfilling your tax obligations by paying
                    all federal, state, and other applicable taxes in accordance
                    with the relevant Applicable Laws.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 11">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    14. Credit Card/PayPal Use:
                  </p>
                  <p>
                    When making payments using a credit card, you affirm that
                    you are the authorized user of the credit card provided. It
                    is your responsibility to promptly inform us of any changes
                    to your credit card account, such as the account number,
                    expiration date, billing address, or if the credit card
                    becomes expired or canceled for any reason. We cannot be
                    held liable for any loss incurred due to unauthorized use of
                    your credit card or any other payment method by a third
                    party (such as PayPal) in relation to the Services. Engaging
                    in fraudulent activities involving credit cards or other
                    payment methods, regardless of the outcome, or failing to
                    honor legitimate charges or payment requests will result in
                    immediate termination of your Account, and may lead to civil
                    litigation and/or criminal prosecution.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    15. Refunds and Cancellations:
                  </p>
                  <p>
                    If there is an error in the Services we provide (at our
                    discretion), we may issue a refund if genuine reasons are
                    proven after investigation.
                  </p>
                  <p>
                    Please carefully read the rules of each Game and Contest
                    before participating.
                  </p>
                  <p>
                    Registrations cannot be canceled once entered, but in
                    exceptional circumstances where the fault lies with us, we
                    will cancel your participation upon request and refund the
                    in-app virtual currency entry fee within a reasonable
                    timeframe.
                  </p>
                  <p>
                    If we cancel your participation in a Game or Contest, we
                    will return your in-app virtual currency entry fee amount to
                    your relevant wallet (Deposit/Bonus) within a reasonable
                    timeframe for you to use it in other Contests.
                  </p>
                  <p>
                    Refunds will be made to the same account used for the
                    initial payment.
                  </p>
                  <p>
                    All amounts credited to the Winnings Wallet or deposited in
                    the Deposit Wallet must be utilized within 365 days.
                    Unutilized amounts after 365 days will no longer be usable,
                    and we are not liable to provide compensation.
                  </p>
                  <p>
                    We are not liable for services provided by third parties on
                    our Application, including downtimes, network failures,
                    glitches, payment failures, and delays on their end.
                  </p>
                  <p>
                    You are responsible for complying with the terms and
                    conditions of relevant third-party payment gateway
                    providers, including their KYC requirements for deposits and
                    withdrawals.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 12">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    16. Restrictions on Application Use:
                  </p>
                  <p>
                    Please take note of the following restrictions when using
                    the Application:
                    <br />
                    The Application and its content should not be used for any
                    purpose that is illegal, unlawful, or prohibited by these
                    Terms or under applicable law.
                    <br />
                    Do not use the Application to host, display, upload, modify,
                    publish, transmit, update, or share any information that
                    belongs to another person without proper rights.
                    <br />
                    Avoid sharing content that is harmful, harassing,
                    defamatory, obscene, pornographic, libelous, invasive of
                    privacy, hateful, or racially or ethnically objectionable.
                    <br />
                    Usage of the Application for money laundering, betting,
                    gambling, or any other unlawful activity is strictly
                    prohibited.
                    <br />
                    Do not harm minors in any way through the use of the
                    Application.
                    <br />
                    Do not infringe upon any patent, trademark, copyright, or
                    other proprietary rights, and ensure compliance with
                    applicable laws.
                    <br />
                    Impersonating another person or containing software viruses
                    or other malicious code is strictly prohibited.
                    <br />
                    Do not threaten the unity, integrity, defense, security, or
                    sovereignty of the United States or any other nation.
                    Additionally, refrain from engaging in activities that
                    threaten public health, safety, or critical information
                    infrastructure.
                    <br />
                    Redistribution, sublicensing, selling, assigning, or
                    transferring the Application/Services/Platform or its
                    components or content to third parties without written
                    permission is prohibited.
                    <br />
                    Do not circumvent or disable any digital rights management,
                    usage rules, or security features of the Application. Also,
                    avoid removing or altering any proprietary notices.
                    <br />
                    Reverse engineering, decompiling, or extracting the source
                    code of the Platform, except where expressly permitted in
                    writing or required by applicable law, is prohibited.
                    <br />
                    Colluding with other players, hacking, fraudulent
                    malpractices, or any other misconduct is strictly forbidden.
                    <br />
                    Usage of robots, spiders, retrieval applications, or other
                    devices to retrieve or index portions of the Platform is
                    prohibited.
                    <br />
                    Collecting information about users for illegal or unlawful
                    purposes is not allowed.
                    <br />
                    Creating multiple accounts or using false pretenses to
                    create an Account is strictly prohibited. KYC details may be
                    requested for identity verification.
                    <br />
                    Accessing the Application through Virtual Private Networks
                    (VPNs) or any other technology from Restricted
                    States/Territories is not permitted.
                    <br />
                    Transmission of viruses, worms, logic bombs, or any
                    destructive items through the Application is prohibited.
                    <br />
                    Do not use the Application in a manner that could damage,
                    disable, or impair the servers, networks, computer systems,
                    or resources connected to the Application.
                    <br />
                    Engaging in denial of service (DoS, DDoS) attacks or any
                    other harmful activities that disrupt the Platform or
                    interfere with other users' experience is strictly
                    forbidden.
                    <br />
                    Manipulating identifiers or disguising the origin of content
                    transmitted through the Application is prohibited.
                    <br />
                    Impersonating another person or misrepresenting affiliation
                    with any entity, including Dwija’s employees, is not
                    allowed.
                    <br />
                    Any fraudulent activity, suspected fraud, or collusion on
                    the Application will result in immediate debarment from
                    participating in any games.
                    <br />
                    Each user is allowed to create only one account on the
                    Application, and providing KYC details may be necessary for
                    verification. Creating multiple accounts or accounts from a
                    single device may result in a ban, and balances in those
                    accounts may be forfeited.
                    <br />
                    Dwija reserves the right to deactivate or delete accounts,
                    forfeit wallet balances, and take appropriate action in the
                    event of fraudulent, illegal, or suspicious activities,
                    including false chargebacks. Any forfeiture of wallet
                    balances will be at Dwija’s sole discretion and will not
                    result in liability on our part.
                    <br />
                    In certain cases, we may provide a right of appeal to users
                    after deleting, closing, or forfeiting balances in their
                    accounts. However, the availability of such right will be
                    determined at our sole discretion.
                    <br />
                    Please note that once amounts have been forfeited, they will
                    not be refunded, except at our sole discretion if an account
                    ban is overturned.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 14">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    17. Privacy Policy:
                  </p>
                  <p>
                    We kindly request that you review our Privacy Policy,
                    accessible at https://www.wolfwinplay.com/privacy, to gain
                    an understanding of how we handle your information when you
                    use the Application/Platform/Services. Any information you
                    provide, including personal information and sensitive data,
                    on the Application will be collected, stored, processed,
                    transferred, or shared by us and our affiliates in
                    accordance with our Privacy Policy. These Terms include the
                    Privacy Policy in its entirety.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    18. Responsible Gaming:
                  </p>
                  <p>
                    We recommend that users maintain a balanced approach while
                    participating in any of the Games/Contests offered on the
                    Application and take necessary precautions to protect
                    themselves from any potential negative consequences.
                  </p>
                  <p>
                    When playing the Game, it is your responsibility to ensure
                    the safety of yourself, others, and any property. You should
                    exercise caution and be mindful of your surroundings and
                    movements at all times. Please be aware that playing the
                    Games or entering Contests is done at your own risk, and we
                    cannot be held liable for any incidents, injuries, or health
                    complications that may arise from your use of the
                    Platform/Application.
                  </p>
                  <p>
                    You are required to adhere to the Fairplay Policy, which can
                    be found at https://www.wolfwinplay.com/fairplay. This
                    policy is an integral part of these Terms and must be
                    followed accordingly.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 15">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    19. Posting content related to the following is strictly
                    prohibited:
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    19.1. Threats, violence, and harm:
                  </p>
                  <p>
                    <br />
                    Making threats of violence or physical/mental harm towards
                    any person.
                    <br />
                    Promoting or encouraging suicide or any form of self-injury,
                    including self-mutilation.
                    <br />
                    Promoting discrimination, hatred, or any form of harm
                    against individuals or groups.
                    <br />
                    Sharing explicit or graphic content related to nudity,
                    gruesome crime or accident scenes, violence, serious injury,
                    or surgical procedures.
                    <br />
                    Sharing content that is excessively shocking, sadistic, or
                    graphic, including content involving animals.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    19.2. Impersonation, spam, and hacking:
                  </p>
                  <p>
                    Impersonating another person or entity with the intent to
                    mislead or deceive others.
                    <br />
                    Sharing links to malicious content intended to damage or
                    disrupt another person's browser or computer.
                    <br />
                    Using the Platform for obtaining sensitive personal
                    information, banking details, credit card details,
                    passwords, etc.
                    <br />
                    Threatening to expose someone's private information or
                    engaging in hacking or unauthorized access to digital
                    information.
                    <br />
                    Engaging in abusive behavior or spamming.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 16">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    19.3. Harassment and bullying:
                  </p>
                  <p>
                    Directing content towards an individual that shames,
                    degrades, or humiliates them.
                    <br />
                    Attacking a person or group based on attributes such as
                    race, religion, ethnicity, sexual orientation, disability,
                    or gender.
                    <br />
                    Sharing content depicting physical or psychological abuse
                    involving minors.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    19.4. Sexually explicit content and violence:
                  </p>
                  <p>
                    Engaging in sexual harassment, making sexual assault
                    threats, or sharing intimate material without consent.
                    <br />
                    Recording or distributing images/videos of sexual assaults.
                    <br />
                    Engaging in cyber stalking, digital dating abuse, or luring
                    sexual trafficking victims.
                    <br />
                    Promoting or depicting violence towards children or sharing
                    sexually explicit material involving children.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    19.5. Breach of third-party rights:
                  </p>
                  <p>
                    Violating the rights of third parties, including copyright,
                    trademark, privacy, and publicity rights.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    19.6. Hate speech and false information:
                  </p>
                  <p>
                    Posting content that is defamatory, obscene, or
                    pornographic.
                    <br />
                    Engaging in or promoting illegal activities.
                    <br />
                    Intending to deceive or mislead others and endangering our
                    trust-based community.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    19.7. Terrorism and illegal activities:
                  </p>
                  <p>
                    Promoting organizations engaged in terrorist activities or
                    inciting violence against others.
                    <br />
                    Seeking to use the Application for illegal activities or
                    activities that violate the Community Guidelines.
                    <br />
                    Disrespecting national symbols, including the national flag
                    and emblem.
                    <br />
                    Offering or soliciting the purchase, sale, or trade of
                    unlawfully acquired goods.
                    <br />
                    Offering, selling, trading, or soliciting firearms,
                    accessories, ammunition, explosive weapons, or instructions
                    on how to manufacture them.
                    <br />
                    If you do not agree with our Community Guidelines, you have
                    the option to delete your Account and/or refrain from
                    accessing, downloading, and using the Application and/or the
                    Services.
                    <br />
                    If you wish to report any violation of our Community
                    Guidelines, you can contact us at contactus@wolfwinplay.com.
                    We will review these reports to determine if there has been
                    a violation and take appropriate action at our discretion.
                    <br />
                    Changes to Community Guidelines: Any changes to the
                    Community Guidelines will be posted on our website,
                    www.getrushapp.com, to reflect the updated guidelines. It is
                    recommended to periodically review this page for the latest
                    information on our community guidelines. Once posted, the
                    changes are effective immediately. By continuing to access
                    or use the Application and/or the Services, you accept the
                    changes and the amended Community Guidelines.
                    <br />
                    Please take these guidelines seriously and adhere to them in
                    the intended spirit. We will do our best to enforce them
                    consistently and fairly. We reserve the right at all times
                    (without any obligation) to remove any content that violates
                    our Terms or Community Guidelines and to take appropriate
                    actions, including suspending users or reclaiming usernames,
                    without liability to you.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 17">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    20. Modifications in Service:
                  </p>
                  <p>
                    We retain the right, at our discretion and without any
                    obligation to provide prior notice, to interrupt, limit,
                    alter, or terminate the Application (or any portion
                    thereof), any Service(s), or the Platform, including changes
                    to the method of delivering the Service(s). You acknowledge
                    and agree that we or our affiliates will not be held
                    responsible to you or any third party for any adjustments,
                    temporary or permanent suspension, or complete cessation of
                    the Application, Services, or Platform.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 18">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    21. Disclaimer of Warranties:
                  </p>
                  <p>
                    The content provided through the
                    Platform/Services/Application may contain technical
                    inaccuracies or typographical errors. We reserve the right
                    to make changes or improvements to the
                    Platform/Services/Application at any time. The content and
                    information available on the Platform/Services/Application
                    are provided "as is" and "as available" without any
                    expressed or implied warranties, to the fullest extent
                    permitted by applicable laws. These include:
                  </p>
                  <p>
                    a. No implied warranty of merchantability or fitness for a
                    particular purpose.
                    <br />
                    b. No guarantee of uninterrupted or error-free content on
                    the Platform/Services/Application.
                    <br />
                    c. No assurance that defects, if any, will be corrected.
                    <br />
                    d. No liability for any harm resulting from downloading or
                    accessing information or material, server quality, games,
                    products, Application, Services, or sites, or cancellation
                    of competitions and winnings.
                    <br />
                    e. No guarantee of constant or uninterrupted availability of
                    the Platform/Services/Application.
                    <br />
                    f. No assurance that installation or uninstallation choices
                    related to the Platform/Services/Application will be
                    successful in all cases.
                    <br />
                    g. No guarantee of personal ability to use the
                    Platform/Services/Application.
                    <br />
                    h. No guarantee of satisfaction with the use of the
                    Platform/Services/Application.
                    <br />
                    i. No assurance that the Platform/Services/Application will
                    meet your requirements and expectations.
                    <br />
                    j. No guarantee of the accuracy of data provided by the
                    Platform/Services/Application.
                    <br />
                    k. No assurance of the security and privacy of your data.
                    <br />
                    l. No guarantee that all bugs or errors will be corrected.
                    <br />
                    m. No guarantee of compatibility with all devices and
                    networks.
                    <br />
                    n. No guarantee that the Platform/Services/Application is
                    fit for a particular purpose or use.
                    <br />
                    o. No guarantee that the Platform/Services/Application and
                    its contents are accessible in every location.
                    <br />
                    p. No guarantee of perpetual security and immunity to
                    breaches of security worldwide.
                  </p>
                  <p>
                    You are solely responsible for accessing, downloading, or
                    obtaining any material through the
                    Platform/Services/Application, and you assume all risks and
                    responsibilities associated with potential damage to your
                    computer system or loss of data.
                  </p>
                  <p>
                    To the extent permitted by law, neither we nor our
                    affiliates, partners, licensors, or associates shall be
                    liable for any direct, indirect, incidental, special, or
                    consequential damages arising from the use or inability to
                    use our sites, even if we have been advised of the
                    possibility of such damages.
                  </p>
                  <p>
                    We, along with our officers, directors, employees,
                    affiliates, and agents, will not be liable for acts or
                    omissions of third parties, including vendors participating
                    in our offerings, unauthorized interception of data, or
                    breaches of this Agreement attributable in part to third
                    parties. We are not responsible or liable for the content or
                    accuracy of any links to other mobile applications and/or
                    websites provided on the Platform.
                  </p>
                  <p>
                    We may suspend or permanently stop providing the
                    Platform/Services/Application (or any part thereof) to you
                    or Users in general, or modify the nature of the Platform
                    and/or these Terms of Use at our sole discretion, without
                    prior notice. Your continued use of the Platform after any
                    modifications constitutes your acceptance of the Agreement
                    (or as modified).
                  </p>
                  <p>
                    To the extent permitted by law, in the event of suspension
                    or closure of the Platform/Services/Application, events, or
                    contests due to government or court orders, passage of laws,
                    Force Majeure Events, or other causes beyond our control,
                    you are not entitled to make any demands or claims.
                  </p>
                  <p>
                    You agree that you are responsible for all data charges
                    incurred through the use of the
                    Platform/Services/Application.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 20">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    22. Intellectual Property Rights:
                  </p>
                  <p>
                    The intellectual property rights in all software underlying
                    the Application, Services, Platform, and materials published
                    on the mentioned portals, including Games, software,
                    advertisements, written content, photographs, graphics,
                    images, illustrations, marks, logos, audio or video
                    clippings, etc., are owned by Dwija, our partners,
                    licensors, and/or associates, as applicable. Without our
                    express written consent, you are prohibited from modifying,
                    publishing, transmitting, participating in the transfer or
                    sale of, reproducing, creating derivative works of,
                    distributing, publicly performing, publicly displaying, or
                    exploiting any of the materials or content on the
                    Application or Platform, either in whole or in part.
                  </p>
                  <p>
                    You acknowledge and agree that you have no ownership or
                    other interest in your Account and that all rights in and to
                    your Account are and shall forever be owned by us for our
                    benefit. We cannot guarantee the authenticity of any data
                    provided by users about themselves. You acknowledge that
                    accessing any content while using the Platform is at your
                    own risk, and you will be solely responsible for any damage
                    or loss incurred by any party as a result.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    23. Copyright Complaints:
                  </p>
                  <p>
                    The Digital Millennium Copyright Act (DMCA) grants copyright
                    owners the means to protect their rights when they believe
                    that their copyrighted work has been infringed by third
                    parties over the Internet. If you believe that your
                    copyrighted work has been copied without your authorization
                    and is available within the Services in a manner that may
                    constitute copyright infringement, you can provide a notice
                    of your claim to the designated agent identified below. To
                    ensure the effectiveness of your notice, it should include
                    the following information:
                  </p>
                  <ol>
                    <li>
                      <p>
                        (a) &nbsp;A physical or electronic signature of a person
                        authorized to act on behalf of the owner of the
                        intellectual property right that is allegedly infringed.
                      </p>
                    </li>
                    <li>
                      <p>
                        (b) &nbsp;A description of the copyrighted work that you
                        claim has been infringed upon.
                      </p>
                    </li>
                    <li>
                      <p>
                        (c) &nbsp;Details of where the material that you claim
                        is infringing is located within this game.
                      </p>
                    </li>
                    <li>
                      <p>
                        (d) &nbsp;Information reasonably sufficient to allow us
                        to contact the complaining party, including address,
                        telephone number, and, if available, an email address
                        for communication.
                      </p>
                    </li>
                    <li>
                      <p>
                        (e) &nbsp;A statement from you, expressing your
                        good-faith belief that the disputed use is not
                        authorized by the copyright owner, its agent, or the
                        law.
                      </p>
                    </li>
                    <li>
                      <p>
                        (f) &nbsp;A statement affirming that the information
                        provided in the notification is accurate and, under
                        penalty of perjury, that the complaining party is
                        authorized to act on behalf of the owner of the
                        exclusive right that is allegedly infringed.
                      </p>
                    </li>
                  </ol>
                  <p>
                    Dwija’ Designated Agent is: Dwija llc. Attn: Customer
                    Service Department, 241 Forest Ave, Paramus, NJ 07652
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 21">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    24. Third Party Sites, Services and Products:
                  </p>
                  <p>
                    We may utilize certain third-party services for verifying
                    your details and facilitating payments. By using these
                    services, you agree to comply with the terms of service and
                    privacy policy of such third parties. You are responsible
                    for staying informed about any changes that may occur in
                    these aforementioned terms as set by the relevant party. We
                    do not have control over the content of any third-party
                    internet site and cannot be held accountable for it.
                  </p>
                  <p>
                    For the provision of Services, certain products, services,
                    or functionality made available to you through the Platform
                    may be delivered by third parties. By using these products,
                    services, or functionality originating from the Platform,
                    you agree and give consent for us to share your information
                    and data with these third parties to the extent necessary to
                    facilitate the provision of the product, service, or
                    functionality.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    25. Limitation of Liability:
                  </p>
                  <p>
                    To the fullest extent permitted by applicable laws, we,
                    along with our affiliates, partners, directors, employees,
                    and agents, shall not be liable to you or any third party
                    for any personal injury or any special, incidental,
                    indirect, punitive, or consequential damages whatsoever.
                    This includes damages for loss of profits or revenues,
                    goodwill, failure to transmit or receive any data, loss of
                    confidential information, business interruption, loss of
                    privacy, corruption or loss of data, failure to receive or
                    backup your data (or archived data), and any other loss
                    arising from or related to the use of the Application or the
                    Services.
                  </p>
                  <p>
                    This limitation applies to any cause of action, including
                    contract, tort (including negligence), or otherwise, and any
                    other loss whatsoever, even if we or any of our affiliates
                    or agents have been advised of the possibility of such
                    damages. It also applies to any third-party content,
                    software, or functions used in connection with the
                    Application.
                  </p>
                  <p>
                    Regardless of anything to the contrary stated in the Terms
                    or elsewhere, you agree that our maximum aggregate liability
                    for all your claims under this agreement, in all
                    circumstances, except for the payment of any withdrawable
                    balance in your user account, shall be limited to US Dollar
                    One Hundred only (USD 100/-).
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 22">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    26. Indemnification:
                  </p>
                  <p>
                    You agree to indemnify, defend, and hold us, our
                    subsidiaries, assignors, assignees, affiliates, partners,
                    owners, and agents, as well as their respective officers,
                    directors, employees, successors, and assigns, harmless from
                    any claim, proceeding, loss, damage, liability, cost,
                    demand, judgment, settlement, or expense (including
                    attorney's fees) of any kind that arises from:
                  </p>
                  <p>
                    (i) Your access to or use of the Application and/or
                    Services.
                    <br />
                    (ii) Any breach of these Terms or Privacy Policy.
                    <br />
                    (iii) Your violation of the rights of a third party,
                    including infringement of any intellectual property,
                    proprietary right, trade secret, privacy, or consumer
                    protection right.
                    <br />
                    (iv) Any violation of law or contractual obligation,
                    including any associated claims, demands, or notices.
                  </p>
                  <p>
                    This provision will continue to apply even after the
                    termination of these Terms.
                  </p>
                  <p>
                    In the event of a claim, we reserve the right, at your
                    expense, to assume the exclusive defense and control of the
                    matter. In such cases, you will fully cooperate with us and
                    assist in asserting any available defenses at our
                    discretion.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 23">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    27. Dispute Resolution and Arbitration:
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    27.1. General Provisions:
                  </p>
                  <p>
                    This section applies to any dispute, except for disputes
                    pertaining to the enforcement or validity of our
                    intellectual property rights. The term "dispute" encompasses
                    any disagreement, legal action, or controversy between you
                    and us regarding these Terms, the Services, or any product,
                    service, or information we provide to you. Disputes may
                    arise from contract, warranty, tort, statute, regulation,
                    ordinance, or any other legal or equitable basis. The term
                    "dispute" is given the widest possible meaning permitted by
                    law. In the event of a dispute, either party must provide a
                    Notice of Dispute to the other party, which should include
                    the party's name, address, contact information, the facts
                    leading to the dispute, and the requested resolution. You
                    should send the Notice of Dispute to Dwija’ Customer
                    Support, 241 Forest Ave, Paramus, NJ 07652, using U.S. Mail.
                    We will send any Notice of Dispute to your address if
                    available, or to your email address. Both parties will make
                    reasonable efforts to resolve the dispute through informal
                    negotiation within sixty (60) days from the date the Notice
                    of Dispute is sent. If the dispute remains unresolved after
                    sixty (60) days, either party may initiate arbitration.
                    Alternatively, if all requirements are met, you may choose
                    to litigate the dispute in small claims court in your county
                    of residence or in Bergen County, New Jersey, without
                    engaging in informal negotiation beforehand.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    27.2. Binding Arbitration:
                  </p>
                  <p>
                    If you and we cannot reach a resolution through informal
                    negotiation or in small claims court, any further attempt to
                    resolve the dispute will be conducted exclusively through
                    binding arbitration as outlined in this section. All
                    disputes will be resolved by a neutral arbitrator, whose
                    decision will be final, except for a limited right of appeal
                    under the Federal Arbitration Act. Any court with
                    jurisdiction over the parties may enforce the arbitrator's
                    award.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    27.3. Class Action Waiver:
                  </p>
                  <p>
                    To the fullest extent permissible under applicable law, any
                    proceedings to resolve or litigate a dispute in any forum
                    will be conducted solely on an individual basis. Neither
                    party will seek to have any dispute heard as a class action
                    or in any proceeding where one party acts or intends to act
                    in a representative capacity. No arbitration or proceeding
                    will be consolidated with another without the written
                    consent of all parties involved in the affected arbitrations
                    or proceedings. If this waiver is deemed illegal or
                    unenforceable for all or some parts of a dispute, it will
                    not apply to those specific parts. Instead, those parts will
                    be severed and pursued in a court of law, while the
                    remaining parts will proceed to arbitration.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 24">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    27.4. Arbitration:
                  </p>
                  <p>
                    If you are situated within the United States, Canada, the
                    United Kingdom, the European Union, or any of their
                    territories, arbitration will be conducted by the American
                    Arbitration Association (AAA) in accordance with its
                    Commercial Arbitration Rules. Both parties agree to initiate
                    arbitration exclusively in New Jersey, USA. You have the
                    option to request a telephonic or in-person hearing as per
                    the AAA rules. For disputes involving $10,000 or less, the
                    hearing will generally be conducted by phone, unless the
                    arbitrator determines that an in-person hearing is
                    warranted. If you are located in a country not listed above,
                    the arbitration will be conducted by the International Court
                    of Arbitration of the International Chamber of Commerce
                    (ICC) following UNCITRAL rules. The arbitration will be
                    conducted in English, and the English version of these Terms
                    (rather than any translation) will prevail. Both parties
                    agree to interpret this arbitration agreement in the
                    broadest manner allowed by applicable laws. The arbitrator
                    may award the same damages to you individually as a court
                    could. However, the arbitrator may only grant declaratory or
                    injunctive relief to you on an individual basis, to the
                    extent necessary to address your specific claim. In case of
                    any conflict with the arbitrators' commercial rules, these
                    Terms will take precedence. The arbitrator is authorized to
                    award compensatory damages but does not have the authority
                    to award non-economic damages, such as those for emotional
                    distress, pain and suffering, or punitive, indirect,
                    incidental, or consequential damages. Each party will bear
                    its own attorneys' fees, costs, and disbursements arising
                    from the arbitration process and will share equally in the
                    arbitrator's fees and costs, as well as those of the AAA.
                    However, the arbitrator may award the prevailing party
                    reasonable attorneys' fees and costs, including expert
                    witness fees and travel expenses. Within fifteen (15)
                    calendar days after the conclusion of the arbitration, the
                    arbitrator will issue a written award and statement of
                    decision, outlining the essential factual findings and legal
                    conclusions on which the award is based, including the
                    calculation of any damages awarded. The award may be entered
                    as a judgment in any court with competent jurisdiction. The
                    parties waive their right to initiate any action or legal
                    proceeding in connection with a dispute covered by this
                    provision, except for the following purposes: (i) enforcing
                    the arbitration award or any other decision by the arbitral
                    tribunal, (ii) compelling the other party to participate in
                    the arbitration proceedings, (iii) requesting any type of
                    temporary or interim relief related to the dispute before
                    the arbitral tribunal is established, (iv) requesting the
                    appearance of witnesses and/or experts, and/or (v)
                    requesting compliance with any information and/or
                    documentation discovery. By accepting this binding
                    arbitration provision, you acknowledge that you are
                    relinquishing certain rights and protections that would
                    otherwise be available if a claim or dispute were resolved
                    through litigation in court. These include, but are not
                    limited to, the right to seek or obtain certain types of
                    damages prohibited by this arbitration provision, the right
                    to a jury trial, certain appellate rights, the ability to
                    bring a claim as a class member in any purported class or
                    representative proceeding, and the ability to invoke formal
                    rules of procedure and evidence.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 25">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    27.5. Time Limit for Claims or Disputes:
                  </p>
                  <p>
                    You must initiate any claim or dispute arising from these
                    Terms within one year from the date the cause of action
                    occurred, to the extent allowed by applicable law. Failure
                    to file a claim or dispute within this one-year period will
                    result in the claim or dispute being permanently barred.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    27.6. Seeking Equitable Relief:
                  </p>
                  <p>
                    You acknowledge that if these Terms are not specifically
                    enforced, it would cause us irreparable harm. Therefore, in
                    addition to any other remedies available to us under the law
                    and despite our agreement to arbitrate disputes, we have the
                    right to seek appropriate equitable remedies for your
                    violation of these Terms in any court of competent
                    jurisdiction, without the need for a bond, other security,
                    or proof of damages.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    27.7. Language of the Terms:
                  </p>
                  <p>
                    In the event that we provide a translated version of these
                    Terms, the User Terms of Service, the Developer Terms and
                    Conditions of Service, the Affiliate Program Terms of
                    Service, the Skillz Privacy Policy, or any other terms or
                    policy, it is solely for informational purposes. If there is
                    any discrepancy between the translated version and the
                    English version, the English meaning will prevail.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 26">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    28. Force Majeure:
                  </p>
                  <p>
                    We shall not be held liable for any circumstances arising
                    directly or indirectly from the use of the Application,
                    Services, or Platform(s) in the event of a Force Majeure
                    Event. A Force Majeure Event refers to occurrences beyond
                    our reasonable control, such as acts of God, declared or
                    undeclared wars or threats of war, insurrections, acts of
                    terrorism, epidemics, pandemics, government actions
                    (including the passage of laws or orders), lockouts, civil
                    unrest, demonstrations, labor disputes, natural disasters,
                    inability to obtain necessary authorizations, accidents,
                    defects in the telecommunication network, or any other acts
                    that affect our ability to provide the Services or maintain
                    the Application. In such cases, it may become difficult or
                    impossible for us to continue offering the Services on the
                    Application or Platform. Therefore, we reserve the right to
                    suspend, limit, or terminate the
                    Platform/Application/Services until further notice.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    29. Communications with You:
                  </p>
                  <p>
                    We may utilize various communication channels, such as
                    email, text messages, telephone, notifications on the
                    Application (including push notifications), or other means,
                    to communicate with you. By using the Application, you agree
                    to receive communications from us, including but not limited
                    to messages related to the Application, Services, your
                    Account information, updates/changes to the
                    Application/Services, as well as promotional or marketing
                    communications.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    30. Entire Agreement:
                  </p>
                  <p>
                    You acknowledge and agree that these Terms, along with the
                    Privacy Policy, shall constitute the entire and
                    comprehensive agreement between you and us, prevailing over
                    any previous agreements, whether oral or written, and any
                    other communications between you and us regarding the
                    subject matter covered by these Terms. If you prefer not to
                    receive communications from us, you have the option to opt
                    out by sending an email to contactus@wolfwinplay.com.
                    However, please note that choosing to opt out may prevent
                    you from participating in Competitions offered by our
                    developer partners or receiving our Services.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 27">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    31. Severability:
                  </p>
                  <p>
                    In the event that any provision of these Terms is deemed
                    unenforceable under applicable law(s), the remaining
                    provisions of these Terms will remain valid and enforceable.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    32. Waiver:
                  </p>
                  <p>
                    If you violate these Terms and we choose not to take
                    immediate action, it does not waive our right to enforce our
                    rights and remedies in any other instance where you breach
                    these Terms.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    33. Termination:
                  </p>
                  <p>
                    Your access to the Application, Services, and Platform may
                    be terminated by us under the following circumstances:
                  </p>
                  <p>
                    a. If you voluntarily uninstall the Application from your
                    device.
                    <br />
                    b. If you knowingly or unknowingly violate, either fully or
                    partially, these Terms or Privacy Policy, as determined by
                    us.
                    <br />
                    c. If your Account remains inactive for a period of more
                    than 365 days.
                    <br />
                    d. If we discover that the same User Details are being used
                    across multiple accounts, we reserve the right to terminate
                    or deactivate the Account without the user's consent, and
                    any remaining wallet balances will not be refunded.
                    <br />
                    e. If termination is required by law.
                    <br />
                    We reserve the right to terminate this Agreement at any
                    time, with or without notice, and may restrict your access
                    to the Application and/or prohibit any future use of the
                    Services.
                    <br />
                    You have the option to terminate this agreement by
                    discontinuing your access to the Application. However,
                    certain obligations outlined in this agreement will continue
                    to be binding even after termination.
                    <br />
                    Upon the termination of these Terms, any legal rights,
                    obligations, and liabilities that you and we have benefited
                    from, been subject to, or accrued during the term of the
                    Agreement will remain unaffected by the cessation and will
                    continue to apply indefinitely.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 28">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    34. Governing Law:
                  </p>
                  <p>
                    The laws of the New Jersey, United States shall govern and
                    interpret these Terms, including any issues or questions
                    that may arise under them.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    35. Customer Support:
                  </p>
                  <p>
                    If you have any questions regarding the Application, its
                    Services, or the Terms, you can reach out to our customer
                    service team at contantus@wolfwinplay.com. Alternatively,
                    you can also access the help and support page within our
                    Application for assistance.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    36. Grievance Officer:
                  </p>
                  <p>
                    If you have any complaints or grievances regarding the use
                    of the Application or its Services, please get in touch with
                    Hiren Savaliya, our Grievance Officer and Compliance
                    Officer, at contantus@wolfwinplay.com. You can send your
                    correspondence to the following address:
                  </p>
                  <p>
                    DWIJA LLC
                    <br />
                    241 Forest Ave,
                    <br />
                    Paramus, NJ 07652
                  </p>
                  <p>Attention: Grievance Officer</p>
                  <p>
                    Upon receiving a consumer complaint, we will acknowledge it
                    within fourty-eight hours and aim to resolve it within 60
                    days from the date of receipt.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    37. Right to Take down:
                  </p>
                  <p>
                    You acknowledge and accept that we have the sole discretion
                    to take down, delete, or remove any content on the
                    Application or related to the Services without providing any
                    prior notice to you. This action may be taken for various
                    reasons, including your breach of these Terms or Privacy
                    Policy, or as required by applicable law
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="page" title="Page 29">
            <div class="section">
              <div class="layoutArea">
                <div class="column">
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    38. Forfeiture:
                  </p>
                  <p>
                    We retain the right to forfeit any account that we identify
                    as inactive, infringing upon intellectual property rights,
                    violating these Terms or Privacy Policy, or containing
                    misleading information.
                  </p>
                  <p
                    style={{
                      fontFamily: "NunitoBlack",
                      fontSize: "20px",
                      color: "#f9c130",
                    }}
                  >
                    39. Refer a Friend Program:
                  </p>
                  <p>
                    We may provide a referral program ("Refer a Friend" or
                    "RAF") on the Application, allowing eligible referrers to
                    receive specific in-app virtual currency rewards ("Rewards")
                    for referring individuals ("invitees") to play on the
                    Application.
                  </p>
                  <p>
                    Eligibility: Users who have signed up and played at least
                    one game on our platform.
                  </p>
                  <p>
                    An eligible referrer will only receive Rewards for referrals
                    where the invitee registers on the Application and completes
                    the sign-up process by clicking on the referrer's shared
                    referral link.
                  </p>
                  <p>
                    The in-app virtual currency Rewards will be added to the
                    eligible referrer's Deposit Wallet.
                  </p>
                  <p>
                    Referral links will be generated from the eligible
                    referrer's Application account, and details of the referrals
                    can be viewed under the "Referrals" tab on the Application.
                  </p>
                  <p>
                    Users engaging in fraudulent activities will not be eligible
                    for Rewards and may be blocked by us.
                  </p>
                  <p>
                    If invitees/users are found to be involved in misconduct or
                    unfair play, we reserve the right to confiscate Rewards from
                    the eligible referrer related to the specific referral.
                  </p>
                  <p>
                    If multiple invitees of a user are found to be engaging in
                    unfair play, they will not be eligible for Rewards and may
                    be blocked by us.
                  </p>
                  <p>
                    If you have any further queries, please contact our customer
                    support team.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
